import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

const NOMES_DOS_MODULOS: Record<number, string> = {
  234: 'Imobiliário',
  2: 'Imobiliário',
  3: 'Imobiliário',
  4: 'Imobiliário',
  5: 'Industrial',
  6: 'Edificações',
  7: 'Infraestrutura',
};

@Component({
  selector: 'app-ficha-bloqueada',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './ficha-bloqueio-modulo.component.html',
  styleUrl: './ficha-bloqueio-modulo.component.scss',
})
export class FichaBloqueioModuloComponent {
  @Input() moduloId: number | null = null;

  readonly resumo = [1, 2, 3, 4, 5];
  readonly numeros = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  readonly empresas = [1, 2];

  private readonly userId = localStorage.getItem('userId');

  readonly moduloIDs = {
    Imobiliario: 234,
    Industrial: 5,
    Edificacoes: 6,
    Infraestrutura: 7,
  };

  get nomeModulo(): string {
    return this.moduloId ? NOMES_DOS_MODULOS[this.moduloId] ?? '' : '';
  }

  getUpgradeLink(): string {
    if (this.userId === '233278' || this.userId === '235633') {
      return 'https://rededeobras.construmarket.com.br/fichas-de-prospeccao?utm_source=admin-rdo&utm_medium=teste&utm_campaign=teste_gratuito';
    }

    switch (this.moduloId) {
      case this.moduloIDs['Imobiliario']:
      case 2:
      case 3:
      case 4:
        return 'https://rededeobras.construmarket.com.br/de-um-upgrade-no-seu-plano-imobiliario/?utm_source=plg-rededeobras&utm_medium=plg-rededeobras&utm_campaign=upgrade-rededeobras-imobili%C3%A1rio+&utm_id=upgrade-rededeobras-imobili%C3%A1rio+';
      case this.moduloIDs['Industrial']:
        return 'https://rededeobras.construmarket.com.br/de-um-upgrade-no-seu-plano-industrial/?utm_source=plg-rededeobras&utm_medium=plg-rededeobras&utm_campaign=upgrade-rededeobras-industrial+&utm_id=upgrade-rededeobras-industrial+';
      case this.moduloIDs['Edificacoes']:
        return 'https://rededeobras.construmarket.com.br/de-um-upgrade-no-seu-plano-edificacoes/?utm_source=plg-rededeobras&utm_medium=plg-rededeobras&utm_campaign=upgrade-rededeobras-edificacoes&utm_id=upgrade-rededeobras-edificacoes';
      case this.moduloIDs['Infraestrutura']:
        return 'https://rededeobras.construmarket.com.br/de-um-upgrade-no-seu-plano-infra/?utm_source=plg-rededeobras&utm_medium=plg-rededeobras&utm_campaign=upgrade-rededeobras-infra+&utm_id=upgrade-rededeobras-infra+';

      default:
        return 'https://app.rededeobras.com.br/';
    }
  }
}